import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CamelCasePipe } from './camel-case.pipe';
import { TimeTakenPipe } from './time-taken.pipe';
import { OrderByPipe } from './order-by.pipe';

@NgModule({
  declarations: [CamelCasePipe, TimeTakenPipe, OrderByPipe],
  imports: [CommonModule],
  exports: [CamelCasePipe, TimeTakenPipe, OrderByPipe],
})
export class PipesModule {}
